module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAAWUlEQVRIiWP8//8/Ay0BE01Np7sFfFNuUj28hlkQ4QN8U27+JycIB48PkAEpvhlYH5Ab7kRbQA1AsQWEfDn4fTBqwagFDIzIdTK1KpxPOeqMWC2gBRj6cQAAkFIjb6SPsHMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_histogram_blue.png
// module id = 335
// module chunks = 1